import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function NavigationHandler() {
  const { key } = useLocation();
  const ioRef = useRef<IntersectionObserver | null>(null);

  // Save scroll position when navigating away from this history entry
  useEffect(() => {
    return () => {
      sessionStorage.setItem(`scroll-${key}`, String(window.scrollY));
    };
  }, [key]);

  // On every route change: restore scroll, then re-attach the intersection observer
  useEffect(() => {
    const saved = sessionStorage.getItem(`scroll-${key}`);
    const targetY = saved ? parseInt(saved, 10) : 0;

    const rafId = requestAnimationFrame(() => {
      window.scrollTo(0, targetY);

      // Rebuild observer so previous route's observations are cleared
      ioRef.current?.disconnect();
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-view');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      ioRef.current = io;

      document.querySelectorAll<Element>('[data-animate]:not(.in-view)').forEach((el) => {
        const rect = el.getBoundingClientRect();
        // Already in or above the viewport — reveal instantly, no animation
        if (rect.top < window.innerHeight) {
          el.classList.add('in-view');
        } else {
          io.observe(el);
        }
      });
    });

    return () => cancelAnimationFrame(rafId);
  }, [key]);

  return null;
}
